module.exports = __webpack_public_path__ + "src/assets/textures/env/fork/fork_512_bake.png";